/**
 * @type {Object}
 * @property {array}  creditNoteData
 */
const initialState = {
    creditNoteData: []
};

/**
 * 
 * @param {Object} state    Initial state of store 
 * @param {Object} action   action data
 * @returns {Object} newState 
 */
const reducerCreditNote = (state = initialState, action) => {
    const newState = { ...state }
    switch (action.type) {
        case 'FEETCH_CREDIT_NOTE_DATA':
            var { data } = action;
            newState.creditNoteData = data;
            break;

        default:
            break;
    }
    return newState;
}

export default reducerCreditNote;